import { FavouriteCondition, FavouriteConditionValue} from 'app/types-shared';
import { Filter } from 'app/components/filters/types';
import { createAdvancedField } from 'app/components/filters/filters-panel/conditions/create-advanced-field';

export const createFavouriteCondition = (
  filter: Filter,
  condValues: FavouriteConditionValue[],
  originalCondition: FavouriteCondition
): FavouriteCondition => {

  const options = filter.menuOptions;

  return {
    ...(!!originalCondition && originalCondition),
    domain: { v: filter.domain },
    ...(!!filter.advancedField && Object.assign({}, {
      domainDbFunction: filter.advancedField.dbFunctionDomain,
      valueOperator: filter.advancedField.valueListOperator,
      conditionOperator: filter.advancedField.conditionOperator
    }, options && createAdvancedField(options, filter.advancedSearchType))),
    values: condValues
  };
};
